import { render, staticRenderFns } from "./FactList.vue?vue&type=template&id=cd2c7618&scoped=true&"
import script from "./FactList.vue?vue&type=script&lang=js&"
export * from "./FactList.vue?vue&type=script&lang=js&"
import style0 from "./FactList.vue?vue&type=style&index=0&id=cd2c7618&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2c7618",
  null
  
)

export default component.exports